// extracted by mini-css-extract-plugin
module.exports = {"denim__section":"denim-blok_denim__section__cRbWb"};